import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { LOGO_URL } from "../lib/assets";

const Footer = () => {
  const { t } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/5 bg-[#080a0d] mt-24">
      <div className="max-w-7xl mx-auto px-5 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img src={LOGO_URL} alt="ScoutOS" className="w-9 h-9 rounded-xl object-cover" />
              <span className="font-display text-lg font-bold text-white">
                Scout<span className="text-blue-500">OS</span>
              </span>
            </div>
            <p className="text-sm text-gray-500 max-w-xs">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t.footer.product}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/search" className="hover:text-gray-300 transition-colors">{t.nav.search}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-300 transition-colors">{t.nav.pricing}</Link></li>
              <li><Link to="/register" className="hover:text-gray-300 transition-colors">{t.nav.signup}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t.footer.company}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/about" className="hover:text-gray-300 transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/contact" className="hover:text-gray-300 transition-colors">{t.nav.contact}</Link></li>
              <li><a href="#" className="hover:text-gray-300 transition-colors">Careers</a></li>
              <li><a href="#" className="hover:text-gray-300 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t.footer.legal}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><a href="#" className="hover:text-gray-300 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-gray-300 transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-600">© {year} ScoutOS. {t.footer.rights}</p>
          <div className="flex items-center gap-4 text-gray-600">
            <a href="#" className="hover:text-gray-400 transition-colors text-xs">Instagram</a>
            <a href="#" className="hover:text-gray-400 transition-colors text-xs">X</a>
            <a href="#" className="hover:text-gray-400 transition-colors text-xs">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
